import { useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { routesProfile } from '../../../consts'
import {
  useCreateSocialOrderDraftMutation,
  useUploadSocialOrderPreviewMutation,
} from '../../../api/socialOrders'
import { DraftSocialOrderForm } from './DraftSocialOrderForm'
import type { CreateSocialOrderFormValues } from './ZodValidationSchema'
import { extractApiErrorMessage } from '../../../utils/api'

export const CreateSocialOrder = () => {
  useLayoutEffect(() => {
    document.title = 'Создание социального заказа'
  }, [])

  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [createSocialOrderDraft] = useCreateSocialOrderDraftMutation()
  const [uploadSocialOrderPreview] = useUploadSocialOrderPreviewMutation()

  const handleSubmitDraft = async (data: CreateSocialOrderFormValues) => {
    setIsLoading(true)
    try {
      const image = data.image
      if (!(image instanceof File)) {
        toast.error('Загрузите изображение социального заказа')
        return
      }

      const { id } = await createSocialOrderDraft({
        payload: {
          title: data.title,
          description: data.description,
          focus: data.focus,
          problem: data.problem,
        },
      }).unwrap()

      await uploadSocialOrderPreview({ socialOrderId: id, file: image }).unwrap()
      toast.success('Социальный заказ создан')
      navigate(`/${routesProfile.SOCIALORDERS.path}/${id}/edit`)
    } catch (error) {
      toast.error(extractApiErrorMessage(error) ?? 'Не удалось создать социальный заказ')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <DraftSocialOrderForm onSubmitDraft={handleSubmitDraft} isLoading={isLoading} />
  )
}
